import React from 'react';
import PropTypes from 'prop-types';

import './AwardWrapper.css';

class Award extends React.Component {
    render() {
        return (
            <div className={ `award-container ${ this.props.pullType ? 'pull-type' : ''}` }>
                <p className="award-category" dangerouslySetInnerHTML={{ __html: this.props.awardCategory }}></p>
                <p className="award-title" dangerouslySetInnerHTML={{ __html: this.props.awardTitle }}></p>
                <p className="award-type" dangerouslySetInnerHTML={{__html: this.props.awardType }}></p>
            </div>
        );
    }
}

Award.propTypes = {
    awardCategory: PropTypes.string.isRequired,
    awardTitle: PropTypes.string.isRequired,
    awardType: PropTypes.string.isRequired,
    pullType: PropTypes.bool //some awards' text don't have the best alignment from the start
};

export default Award;


// WEBPACK FOOTER //
// ./src/components/global/Award/index.js